import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import options from '@/configs/vuetify'

const vuetify = createVuetify({
  components,
  directives,
  ...options,
})

export default vuetify
